module.exports = "<svg viewBox=\"0 0 22 17\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.787 16.903a.867.867 0 0 1-.614-.257L1.133 9.53a.9.9 0 0 1-.006-1.26c.34-.348.892-.35 1.235-.004l6.38 6.448L20.29 1.197a.86.86 0 0 1 1.23-.087c.365.323.403.885.086 1.256l-12.16 14.23a.863.863 0 0 1-.627.306h-.033z\" fill=\"#777\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/scripts/components/shared/InlineEditor/images/check-mark.svg
// module id = UAZS
// module chunks = 89